import { Injectable } from '@angular/core';
import { Observable, of } from "rxjs";
import { StorageServiceInterface } from "common";


@Injectable({
  providedIn: 'root'
})
export class StorageService implements StorageServiceInterface {
  storeItem(key: string, value: string): Observable<void> {
    localStorage.setItem(key, value);
    return of(void 0);
  }

  storeItems(key: string, values: string[]): Observable<void> {
    localStorage.setItem(key, values.join(';'));
    return of(void 0);
  }

  getItem(key: string): Observable<string | null> {
    return of(localStorage.getItem(key));
  }

  hasItem(key: string): Observable<boolean> {
    return of(!!localStorage.getItem(key));
  }

  getItems(key: string): Observable<string[] | null> {
    const v = localStorage.getItem(key);
    if (v) {
      return of(v.split(';'));
    }
    return of(void 0);
  }

  removeItem(key: string) {
    return localStorage.removeItem(key);
  }

  cleanAll() {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      this.removeItem(key);
    });
  }
}
